import logoImage from "@/assets/images/logo.png";
import { cn } from "@/utils";
import { NavLink } from "react-router";

interface Props {
	size?: number | string;
	className?: string;
}
function Logo({ size = 50, className }: Props) {
	// const { themeTokens } = useTheme();

	return (
		<NavLink to="/" className={cn(className)}>
			<img src={logoImage} alt="Logo" style={{ width: size, height: size }} />
		</NavLink>
	);
}

export default Logo;
